<script>
import formatDate, { formatLunar } from '@utils/format-date'
import { parseStringToDateTime } from '@utils/parse-string-to-date'

export default {
  filters: {
    formatLunar,
  },
  props: {
    input: {
      type: String,
      default: () => '',
    },
    field: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    inputData: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      other: '',
      otherIsSelect: false,
      date: null,
      time: '吉時',
      pickerOptions: {
        disabledDate(selectDate) {
          return selectDate.getTime() > Date.now()
        },
      },
    }
  },
  computed: {
    data() {
      const dateText = this.date ? formatDate(parseStringToDateTime(this.date, 'yyyy-MM-dd'), 'dateText') : '';

      return this.date ? `${dateText} (${formatLunar(`${this.date} 00:00:00`, 'order-birth')} ${this.time})` : ''
    },
    lunarData() {
      return this.date ? `${formatLunar(`${this.date} 00:00:00`, 'birth')} ${this.time}` : ''
    }
  },
  watch: {
    inputData: {
      handler(v, ov) {
        this.setFromData()
      },
      deep: true,
    },
    data: {
      handler(v, ov) {
        this.$emit('update:inputData', v)
      },
      deep: true,
    },
  },
  mounted() {
    this.setFromData()
  },
  methods: {
    setFromData() {
      this.$nextTick(() => {
        // this.data = this.inputData;
      })
    },
  },
  inject: ['$validator'],
}
</script>
<template>
  <div>
    <b-field class="is-style-extrafield-birth">
      <b-field
        :message="errors.first(name)"
        :type="{ 'is-danger': errors.has(name) }"
        :class="{ [$style['isRequired']]: field.required }"
        :label="`${field.title}`"
      >
        <div class="columns">
          <div class="column" :class="$style.birthColumn">
            <el-date-picker
              v-model="date"
              prefix-icon="el-icon-date"
              format="yyyy年M月dd日"
              placeholder="選擇國曆生日或創辦年份"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              :clearable="true"
              class="is-style-extrafield"
              popper-class="is-style-extrafield"
            ></el-date-picker>
          </div>
          <div class="column">
            <b-select
              v-model="time"
              v-validate="'required'"
              class="has-radius-danger"
              data-vv-as="吉時"
              placeholder="吉時"
              :name="`${field.id}_${field.alias}_time`"
              expanded
            >
              <option value="吉時">吉時</option>
              <option value="子時">子時 23:00~01:00</option>
              <option value="丑時">丑時 01:00~03:00</option>
              <option value="寅時">寅時 03:00~05:00</option>
              <option value="卯時">卯時 05:00~07:00</option>
              <option value="辰時">辰時 07:00~09:00</option>
              <option value="巳時">巳時 09:00~11:00</option>
              <option value="午時">午時 11:00~13:00</option>
              <option value="未時">未時 13:00~15:00</option>
              <option value="申時">申時 15:00~17:00</option>
              <option value="酉時">酉時 17:00~19:00</option>
              <option value="戌時">戌時 19:00~21:00</option>
              <option value="亥時">亥時 21:00~23:00</option>
            </b-select>
          </div>
          <a :class="$style.exLink" target="_blank" href="http://www.nongli.info/">農曆轉國曆</a>
        </div>
      </b-field>
    </b-field>
    <div v-if="lunarData" style="margin-top: -30px;margin-bottom: 20px;font-size: 15px;color: #BF7E45;">{{lunarData}}</div>
  </div>
</template>
<style lang="scss" module>
.isRequired {
  :global(.label::after) {
    margin-left: 4px;
    color: $color-danger;
    content: '*';
  }
}
.birthColumn{
  @include mobile{
    margin-top: 40px;
  }
}
.exLink {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;
  text-decoration: underline;
  @include mobile {
    top: 30px;
    left: 0;
  }
  @include mobile-smaller{
    top:50px
  }
}
</style>
